import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { LogoPlaceholder } from './Placeholders';
const NAV_LINKS = [{
  href: '#historia',
  label: 'Historia'
}, {
  href: '#proceso',
  label: 'Proceso'
}, {
  href: '#productos',
  label: 'Productos'
}, {
  href: '#visitanos',
  label: 'Visitanos'
}, {
  href: '#contacto',
  label: 'Contacto'
}];
export function Hero() {
  const [menuOpen, setMenuOpen] = useState(false);
  return <section className="relative bg-negro w-full min-h-screen flex flex-col overflow-hidden" data-id="element-28">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-29">
        <img src="https://cdn.magicpatterns.com/uploads/w4UngRu2B6CFqM9pLKGzti/Fondo_P1.png" alt="Calle empedrada de Purmamarca con el Cerro de los Siete Colores al fondo" className="w-full h-full object-cover object-right md:object-center" data-id="element-30" />
      </div>

      {/* Gradient overlay — clear on top half, darker towards the bottom */}
      <div className="absolute inset-0 z-10" style={{
      background: 'linear-gradient(to bottom, rgba(13,13,13,0) 0%, rgba(13,13,13,0) 50%, rgba(13,13,13,0.85) 85%, rgba(13,13,13,1) 100%)'
    }} aria-hidden="true" data-id="element-31"></div>

      {/* Floating top nav over the image */}
      <header className="relative z-30 w-full" data-id="element-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-6 md:pt-8 flex items-center justify-between" data-id="element-33">
          <a href="#" aria-label="Inicio" className="translate-x-4 -translate-y-8 md:-translate-y-12 inline-block" data-id="element-34">
            <LogoPlaceholder className="w-44 h-44 bg-transparent" src="https://cdn.magicpatterns.com/uploads/a1uBNmrLGfkF5MPxY5MTuU/ISOLOGO_NB_SF.png" data-id="element-35" />
          </a>

          <nav className="hidden md:flex items-center gap-4 -translate-y-12" data-id="element-36">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-crema font-labrada font-medium text-lg tracking-wider px-5 py-2 rounded-full bg-negro/30 backdrop-blur-sm border border-crema/15 hover:bg-negro/50 transition-colors" data-id="element-37">
                {link.label}
              </a>)}
          </nav>

          <button onClick={() => setMenuOpen(open => !open)} className="md:hidden text-crema p-2 -translate-y-8" aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={menuOpen} aria-controls="mobile-menu" data-id="element-38">
            {menuOpen ? <XIcon className="w-6 h-6" data-id="element-39" /> : <MenuIcon className="w-6 h-6" data-id="element-40" />}
          </button>
        </div>

        {/* Mobile dropdown menu */}
        <div id="mobile-menu" className={`md:hidden overflow-hidden transition-[max-height,opacity] duration-300 ease-out ${menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-41">
          <nav className="mx-6 -mt-4 mb-2 flex flex-col gap-2 rounded-2xl bg-negro/70 backdrop-blur-md border border-crema/15 p-4" data-id="element-42">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setMenuOpen(false)} className="text-crema font-labrada font-medium text-lg tracking-wider px-4 py-3 rounded-xl hover:bg-negro/50 transition-colors" data-id="element-43">
                {link.label}
              </a>)}
          </nav>
        </div>
      </header>

      {/* Hero content — pushed to bottom over the dark gradient area */}
      <div className="relative z-20 flex-1 flex items-end pb-16 md:pb-24" data-id="element-44">
        <div className="text-left px-6 md:px-12 max-w-7xl mx-auto w-full flex flex-col items-start" data-id="element-45">
          <h1 className="font-labrada font-bold text-4xl md:text-7xl text-crema mb-6 leading-tight inline-block px-6 py-3 bg-negro/30 backdrop-blur-sm border border-crema/15 rounded-2xl -translate-y-[240px] md:-translate-y-10 text-center md:text-left" data-id="element-46">
            Textiles Ancestrales <br className="hidden md:block" data-id="element-47" /> para usar y
            vivir
          </h1>
          <p className="font-labrada text-xl md:text-2xl text-crema/90 mb-10 max-w-2xl" data-id="element-48">
            Artesanía familiar de fibras naturales — Quebrada de Humahuaca,
            Jujuy
          </p>
          <a href="#visitanos" className="bg-marron text-crema font-labrada px-8 py-4 rounded-full hover:opacity-90 transition-opacity text-lg border border-crema/10" data-id="element-49">
            Cómo llegar
          </a>
        </div>
      </div>
    </section>;
}